import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useState, useCallback, useEffect } from 'react';
import { createPopper } from '@popperjs/core';
import styled from 'styled-components';
import { color } from 'styled-system';
import deepmerge from 'deepmerge';
import { useMergeRefs } from 'use-callback-ref';
import { Portal } from '../Portal/Portal.es.js';
import { Box } from '../Box/Box.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '../../utils/assertions.es.js';
import { warn } from '../../utils/functions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { forwardRef } from '../../system/forwardRef.es.js';
import { TransitionBase } from '../TransitionBase/TransitionBase.es.js';
import { matchWidth } from './modifiers.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Arrow = styled("span").attrs(function () {
  return {
    "data-popper-arrow": true,
    role: "presentation"
  };
}).withConfig({
  componentId: "sc-14s8iug-0"
})(["--popper-arrow-size:", ";visibility:hidden;&,&::before{position:absolute;width:var(--popper-arrow-size,8px);height:var(--popper-arrow-size,8px);background-color:inherit;}&::before{inset:0;visibility:visible;content:'';transform:rotate(45deg);", ";}[data-popper-placement^='top'] &{bottom:calc(var(--popper-arrow-size) / -2);}[data-popper-placement^='bottom'] &{top:calc(var(--popper-arrow-size) / -2);}[data-popper-placement^='left'] &{right:calc(var(--popper-arrow-size) / -2);}[data-popper-placement^='right'] &{left:calc(var(--popper-arrow-size) / -2);}"], function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 8 : _ref$size;
  return size + "px";
}, color);
var defaultPopperOptions = {
  placement: "auto",
  modifiers: [{
    name: "offset",
    options: {
      offset: [0, 8]
    }
  }],
  strategy: "absolute"
};
var PopperRoot = forwardRef(function (props, forwardedRef) {
  var _a = props,
      children = _a.children,
      anchorRef = _a.anchorRef,
      triggerRef = _a.triggerRef,
      isOpen = _a.isOpen,
      onClose = _a.onClose,
      onOpen = _a.onOpen,
      matchWidth$1 = _a.matchWidth,
      _a$popperOptions = _a.popperOptions,
      popperOptionsProp = _a$popperOptions === void 0 ? {} : _a$popperOptions,
      _a$transitionComponen = _a.transitionComponent,
      TransitionComponent = _a$transitionComponen === void 0 ? TransitionBase : _a$transitionComponen,
      disablePortal = _a.disablePortal,
      _a$usePortal = _a.usePortal,
      usePortal = _a$usePortal === void 0 ? true : _a$usePortal,
      onClickOutside = _a.onClickOutside,
      _a$isLazy = _a.isLazy,
      isLazy = _a$isLazy === void 0 ? true : _a$isLazy,
      _a$keepMounted = _a.keepMounted,
      keepMounted = _a$keepMounted === void 0 ? false : _a$keepMounted,
      _a$zIndex = _a.zIndex,
      zIndex = _a$zIndex === void 0 ? 1 : _a$zIndex,
      rest = __objRest(_a, ["children", "anchorRef", "triggerRef", "isOpen", "onClose", "onOpen", "matchWidth", "popperOptions", "transitionComponent", "disablePortal", "usePortal", "onClickOutside", "isLazy", "keepMounted", "zIndex"]);

  warn({
    condition: disablePortal !== void 0,
    message: "disablePortal prop is deprecated and will be removed in v1, use usePortal instead"
  });
  var popupRef = useRef(null);
  var popperRef = useRef(null);
  var mergedRefs = useMergeRefs([popupRef, forwardedRef]);

  var _useState = useState(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  var _useState2 = useState(false),
      hasBeenOpened = _useState2[0],
      setHasBeenOpened = _useState2[1];

  var popperOptions = deepmerge(__spreadValues(__spreadValues({}, defaultPopperOptions), {
    modifiers: [__spreadProps(__spreadValues({}, matchWidth), {
      enabled: !!matchWidth$1
    })]
  }), popperOptionsProp);
  var handleOpen = useCallback(function () {
    if (!anchorRef.current || !popupRef.current || isLazy && !isOpen) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      popperRef.current = null;
    }

    var popper = createPopper(anchorRef.current, popupRef.current, popperOptions);
    popperRef.current = popper;
    popperRef.current.forceUpdate();
    setHasBeenOpened(true);
    onOpen == null ? void 0 : onOpen();
  }, [anchorRef, isLazy, isOpen, popperOptions, onOpen]);
  var handleClose = useCallback(function () {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    popperRef.current = null;
    onClose == null ? void 0 : onClose();
  }, [onClose]);

  var handleOutsideClick = function handleOutsideClick(event) {
    if (!isOpen) {
      return;
    }

    if (onClickOutside) {
      onClickOutside(event);
    }
  };

  var handleEnter = function handleEnter() {
    setIsMounted(true);
  };

  var handleExited = function handleExited() {
    setIsMounted(false);
    handleClose();
  };

  useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  useEffect(function () {
    handleOpen();
  }, [handleOpen]);
  useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  useOnClickOutside([anchorRef, popupRef].concat(_toConsumableArray(triggerRef ? [triggerRef] : [])), handleOutsideClick);
  var transitionComponentProps = {
    in: isOpen,
    onEnter: handleEnter,
    onExited: handleExited
  };

  if (isLazy) {
    if (!isOpen && !isMounted) {
      if (!keepMounted || keepMounted && !hasBeenOpened) {
        return null;
      }
    }
  }

  return (
    /* @__PURE__ */
    React.createElement(Portal, {
      isDisabled: disablePortal || !usePortal,
      zIndex: zIndex
    },
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      ref: mergedRefs,
      sx: {
        position: popperOptions.strategy,
        visibility: !isMounted ? "hidden" : "visible",
        zIndex: zIndex
      }
    }, rest),
    /* @__PURE__ */
    React.createElement(TransitionComponent, __spreadValues({}, transitionComponentProps), children)))
  );
});
var Popper = Object.assign(PopperRoot, {
  Arrow: Arrow
});
export { Arrow, Popper };